// extracted by mini-css-extract-plugin
module.exports = {"OASIS-B":"OASIS1_OASIS-B__mLIIu"};